<script>
    let liked = false
</script>
<button on:click={()=>{liked = !liked}} class="gg-heart"></button>
<style>
 .gg-heart,
.gg-heart::after {
 border: 2px solid;
 border-top-left-radius: 100px;
 border-top-right-radius: 100px;
 width: 10px;
 height: 8px;
 border-bottom: 0
}

.gg-heart {
 box-sizing: border-box;
 position: relative;
 transform:
 translate(
 calc(-10px / 2 * var(--ggs,1)),
 calc(-6px / 2 * var(--ggs,1))
 )
 rotate(-45deg)
 scale(var(--ggs,1));
 display: block;
 margin-left: 30px;
 padding:0;
 background-color: pink;
}

.gg-heart::after,
.gg-heart::before {
 content: "";
 display: block;
 box-sizing: border-box;
 position: absolute
}

.gg-heart::after {
 right: -9px;
 transform: rotate(90deg);
 top: 5px
}

.gg-heart::before {
 width: 11px;
 height: 11px;
 border-left: 2px solid;
 border-bottom: 2px solid;
 left: -2px;
 top: 3px
} 
</style>